import { datatableFormaterStringified } from '@clickadilla/datatable-formatter';
import createPagesFromResource from '@/classes/createPages';
import handleErrors from '@/services/handle-errors';
import http, { cancelTokenNames } from '../../http';
import urlFormatter from '../../url-formatter';

const getURL = urlFormatter({
  list: '/api/v1/admin/panel-pages',
  archive: '/api/v1/admin/panel-pages/{id}/archive',
  unarchive: '/api/v1/admin/panel-pages/{id}/unarchive',
  addPages: '/api/v1/admin/panel-pages',
  update: '/api/v1/admin/panel-pages/{id}',
});

export default {
  list() {
    const endpoint = getURL('list');

    return http.get(endpoint)
      .then((response) => response.data.data.map(createPagesFromResource));
  },
  async table({
    headers, options, search,
  }) {
    const requestBody = datatableFormaterStringified({
      headers,
      options,
      search,
    });
    const endpoint = getURL('list');
    const response = await http.get(`${endpoint}?${requestBody}`, {
      applyCancelAdapter: cancelTokenNames.PAGES_TABLE,
    });

    return {
      items: response.data.data.map(createPagesFromResource),
      totalItemsCount: response.data.recordsFiltered,
    };
  },
  archive(id) {
    const endpoint = getURL('archive', { id });

    return http.post(endpoint)
      .catch((error) => handleErrors(error));
  },
  unarchive(id) {
    const endpoint = getURL('unarchive', { id });

    return http.post(endpoint)
      .catch((error) => handleErrors(error));
  },
  update(id, payload) {
    const endpoint = getURL('update', { id });

    return http.put(endpoint, payload)
      .then((response) => response.data)
      .catch((error) => handleErrors(error));
  },
  save(payload) {
    const endpoint = getURL('addPages');

    return http.post(endpoint, payload)
      .then((response) => response.data)
      .catch(handleErrors);
  },
  getURL,
};
